import type { ReactNode } from 'react';

import { RegrasAlcadaGenericasPage } from './alcadasGenericas/RegrasAlcadaGenericasPage';
import { AlcadasValorPage } from './alcadasValor/AlcadasValorPage';
import { FluxoAssinaturaPage } from './assinatura/FluxoAssinaturaPage';
import { GovbrOperacoesPage } from './assinatura/GovbrOperacoesPage';
import { PoliticaAssinaturaPage } from './assinatura/PoliticaAssinaturaPage';
import { ProvedoresAssinaturaPage } from './assinatura/ProvedoresAssinaturaPage';
import { AtesteParametrosPage } from './configuracoes/AtesteParametrosPage';
import { ConfiguracoesGeraisPage } from './configuracoes/ConfiguracoesGeraisPage';
import { ConfiguracoesHub } from './configuracoes/ConfiguracoesHub';
import { DesvioAlertaPage } from './configuracoes/DesvioAlertaPage';
import { MatrizAcoesLotePage } from './configuracoes/MatrizAcoesLotePage';
import { PrazoFechamentoPage } from './configuracoes/PrazoFechamentoPage';
import { SlasInstitucionaisPage } from './configuracoes/SlasInstitucionaisPage';
import { TrabalhosAgendadosPage } from './configuracoes/TrabalhosAgendadosPage';
import { DiasLetivosPage } from './diasLetivos/DiasLetivosPage';
import { PrazosSistemaPage } from './prazosSistema/PrazosSistemaPage';
import { PrecosPublicosPage } from './precosPublicos/PrecosPublicosPage';
import { TiposMultaPage } from './tiposMulta/TiposMultaPage';

/**
 * As telas de configuração e parametrização de negócio, por caminho.
 *
 * Mesmo desenho de `parametrizacao/telas.tsx`: fica fora do `App.tsx` porque são
 * treze entradas e o roteador não deve virar catálogo. O `App.tsx` só espalha
 * este objeto dentro de `TELAS_PRONTAS` — a rota continua nascendo do mapa de
 * navegação, como manda `nucleo/navegacao/mapa.ts`.
 *
 * Duas telas de parametrização mais antigas — reajuste anual e SLA de aprovação
 * SME — seguem declaradas direto no `App.tsx`: são anteriores a este arquivo, e
 * movê-las misturaria reorganização com entrega. As alçadas genéricas, que
 * estavam na mesma situação, vieram para cá em 2026-09-14, porque são uma das
 * 25 telas da rodada de aderência e o teste que confere a rodada lê os
 * catálogos — tela registrada só no roteador ficava invisível para ele.
 */

/**
 * `/admin/configuracoes`, não sob `/admin/parametros`: no protótipo,
 * "Configurações" é grupo de menu irmão de "Parametrização", não filho dela
 * (`AppSidebar.tsx`, `label: 'Configurações'`). Decisão do dono, 2026-08-31.
 */
const CONFIGURACOES = '/admin/configuracoes';

export const TELAS_DE_CONFIGURACAO: Record<string, ReactNode> = {
  // ONDA-T1 — Configurações administrativas
  [CONFIGURACOES]: <ConfiguracoesHub />,
  [`${CONFIGURACOES}/gerais`]: <ConfiguracoesGeraisPage />,
  [`${CONFIGURACOES}/fechamento`]: <PrazoFechamentoPage />,
  [`${CONFIGURACOES}/desvio-alerta`]: <DesvioAlertaPage />,
  [`${CONFIGURACOES}/ateste`]: <AtesteParametrosPage />,
  [`${CONFIGURACOES}/slas`]: <SlasInstitucionaisPage />,
  [`${CONFIGURACOES}/acoes-em-lote`]: <MatrizAcoesLotePage />,
  [`${CONFIGURACOES}/agendamentos`]: <TrabalhosAgendadosPage />,

  // ONDA-T3 — Parametrizações de negócio
  '/admin/parametros/precos-publicos': <PrecosPublicosPage />,
  '/admin/parametros/tipos-multa': <TiposMultaPage />,
  '/admin/parametros/dias-letivos': <DiasLetivosPage />,
  '/admin/parametros/prazos/sistema': <PrazosSistemaPage />,
  '/admin/parametros/workflows/alcadas': <AlcadasValorPage />,
  '/admin/parametros/workflows/alcadas-genericas': <RegrasAlcadaGenericasPage />,

  // ONDA-T4 — Assinatura digital e login gov.br
  '/admin/parametros/govbr-operacoes': <GovbrOperacoesPage />,
  '/admin/parametros/politica-assinatura': <PoliticaAssinaturaPage />,
  '/admin/parametros/provedores-assinatura': <ProvedoresAssinaturaPage />,
  '/admin/parametros/fluxo-assinatura': <FluxoAssinaturaPage />,
};
